import Icon from "./logo";
var CnLayoutFooterPrototype = {
  title: '页尾',
  componentName: 'CnLayoutFooter',
  // category: '图表',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  configure: [{
    name: 'isCnLayoutFooter',
    title: 'CnLayoutFooter',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutFooterPrototype };